import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", function () {
    const trackParams = {
        'utm_source': 'utm_source',
        'utm_medium': 'utm_medium',
        'utm_campaign': 'utm_campaign',
        'utm_term': 'utm_term',
        'mc_cid': 'mc_cid',
        'mc_eid': 'mc_eid',
        'referring_site': 'referring_site',
        'name_first': 'first',
        'name_last': 'last',
        'company-field': 'company',
        'email-field': 'email',
    };

    const urlParams = new URLSearchParams(window.location.search);
    let hasParams = false;

    Object.keys(trackParams).forEach(param => {
        const paramValue = urlParams.get(trackParams[param]);

        // Check if the parameter is valid
        if (paramValue && paramValue.toLowerCase() !== 'pantheon_stripped') {
            // Set the parameter as a cookie
            Cookies.set(param, paramValue, { expires: 10 });
            hasParams = true;
        } else {
            // Check if a cookie exists for the parameter
            const cookieValue = Cookies.get(param);
            if (cookieValue) {
                hasParams = true;
            }
        }
    });

    // If parameters or cookies exist, append them to the hero button's href
    if (hasParams) {
        const heroButton = document.getElementById('heroButton');
        if (heroButton) {
            let href = heroButton.getAttribute('href');
            const url = new URL(href);

            Object.keys(trackParams).forEach(param => {
                const cookieValue = Cookies.get(param);
                if (cookieValue) {
                    url.searchParams.set(trackParams[param], cookieValue);
                } else if (urlParams.has(trackParams[param]) && urlParams.get(trackParams[param]).toLowerCase() !== 'pantheon_stripped') {
                    url.searchParams.set(trackParams[param], urlParams.get(trackParams[param]));
                }
            });

            heroButton.setAttribute('href', url.toString());
        }
    }
});


document.addEventListener('DOMContentLoaded', () => {
    // Observer to ensure the form is loaded before populating fields
    const observer = new MutationObserver((mutations, observer) => {
        const formLoaded = document.querySelector('.utm_source input');
        if (formLoaded) {
            populateUtmFields();
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Define the function to populate UTM fields
    function populateUtmFields() {
        const params = new URLSearchParams(window.location.search);
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'mc_eid', 'mc_cid'];

        utmParams.forEach(param => {
            const paramValue = params.get(param) ? params.get(param).toLowerCase() : null;
            const cookieValue = Cookies.get(param);
            const field = document.querySelector(`.${param} input`);

            if (field) {
                if (paramValue && paramValue !== 'pantheon_stripped') {
                    field.removeAttribute('value');
                    field.value = paramValue; 
                } else if (!paramValue && cookieValue) {
                    field.removeAttribute('value');
                    field.value = cookieValue;
                } else if (paramValue === 'pantheon_stripped') {
                    field.removeAttribute('value');
                    field.value = cookieValue ? cookieValue : '';
                }
            }
        });
    }
});